export default __webpack_public_path__ + "static/media/Icon=Country.d2e2d949.svg";